import type { PuntosEntregaRepositoryPort } from './ports/PuntosEntregaRepositoryPort.ts';

/** Discriminates `punto_entrega.lugar_id` between synced catalog and legacy `lugares`. */
export type PuntoEntregaLugarOrigen = 'catalogo' | 'legacy';

export type PuntoEntregaLugarRef = {
  lugarId: number;
  lugarOrigen: PuntoEntregaLugarOrigen;
};

export function isPuntoEntregaLugarOrigen(v: string): v is PuntoEntregaLugarOrigen {
  return v === 'catalogo' || v === 'legacy';
}

/** Resolves origin for a newly selected place id (catalog row wins when both share numeric id). */
export function resolveLugarOrigenForSelection(
  repo: Pick<PuntosEntregaRepositoryPort, 'findPuntosEntregaCatalogoById'>,
  lugarId: number,
): PuntoEntregaLugarOrigen | '' {
  if (lugarId <= 0) return '';
  return repo.findPuntosEntregaCatalogoById(lugarId) != null ? 'catalogo' : 'legacy';
}

export function legacyLugarNombreInComuna(
  repo: Pick<PuntosEntregaRepositoryPort, 'listBarriosByComuna' | 'listLugaresByBarrio'>,
  comunaId: number,
  lugarId: number,
): string {
  if (comunaId <= 0 || lugarId <= 0) return '';
  for (const b of repo.listBarriosByComuna(comunaId)) {
    const n = repo.listLugaresByBarrio(b.id).find((l) => l.id === lugarId)?.nombre;
    if (n) return n;
  }
  return '';
}

export function legacyLugarExistsInComuna(
  repo: Pick<PuntosEntregaRepositoryPort, 'listBarriosByComuna' | 'listLugaresByBarrio'>,
  comunaId: number,
  lugarId: number,
): boolean {
  return legacyLugarNombreInComuna(repo, comunaId, lugarId).length > 0;
}
